import Vue from 'vue'

import TitleShow from '@/components/TitleShow/index'
// import PieCharts from '@/components/echarts/PieCharts/index'
// import SchoolCharts from '@/components/echarts/SchoolCharts/index'
// import LineCharts from '@/components/echarts/LineCharts/index'
import HeadNav from '@/components/headnav/head-nav.vue'
Vue.component('TitleShow', TitleShow)
// Vue.component('PieCharts', PieCharts)
// Vue.component('LineCharts', LineCharts)
// Vue.component('SchoolCharts', SchoolCharts)
Vue.component('HeadNav', HeadNav)

